import {Component,OnInit,ViewChild} from '@angular/core';
import {PasswordParamsService} from "@components/admin/parametre/authentification/generalites/password-params.service";
import {LoginType} from "@domain/admin/parametre/authentification/generalites/password-params";
import {TranslateService} from "@ngx-translate/core";
import {BehaviorSubject} from "rxjs";
import {FloatingButtonAction,TypeAction} from "@share/component/floating-button/floating-button";
import {NgForm} from "@angular/forms";

/**
 * Composant d'affichage de la page Authentification Généralités
 *
 * @author Lionel Gimenez
 * @date 25/07/2025
 */
@Component({
    host: {'data-test-id': 'generalites'},
    selector: 'generalites',
    templateUrl: './generalites.component.html',
    providers: [
        PasswordParamsService
    ]
})
export class GeneralitesComponent implements OnInit {
    /** Formulaire */
    @ViewChild('form') form: NgForm;

    /** Liste des types pour le select */
    listeLoginType: Array<{ type: LoginType,libelle: string }> = [
        {
            type: LoginType.LOCAL,
            libelle: this.translateService.instant("admin.parametres.authentification.generalites.locale")
        },
        {
            type: LoginType.SAML,
            libelle: this.translateService.instant("admin.parametres.authentification.generalites.saml")
        }
    ];

    /** Liste des actions possibles */
    listeActions: BehaviorSubject<Array<FloatingButtonAction>> = new BehaviorSubject<Array<FloatingButtonAction>>(null);

    /**
     * Constructeur
     */
    constructor(
        public passwordParamsService: PasswordParamsService,
        private translateService: TranslateService,
    ) {
    }

    /**
     * Hook initialisation
     */
    ngOnInit(): void {
        //Initialisation des actions possibles
        this.listeActions.next([{
            type: TypeAction.PRIMARY,
            icone: 'nio icon-sauvegarde',
            libelle: 'global.actions.enregistrer',
            doAction: () => this.passwordParamsService.save(),
            isDisabled: () => !this.form?.valid
        }]);
    }
}
